import type { EDITOR_DATA, EDITOR_PARAMS } from './types'

import { DEFAULT_MARGIN, DEFAULT_PADDING, DEFAULT_WIDTH } from '../const'

const DEFAULT_EDITOR_PARAMS_DEVICE = () => ({
  hidden: false,
  width: DEFAULT_WIDTH(),
  padding: DEFAULT_PADDING(),
  margin: DEFAULT_MARGIN(),
})

export const DEFAULT_EDITOR_PARAMS = (): EDITOR_PARAMS => ({
  mobile: DEFAULT_EDITOR_PARAMS_DEVICE(),
  tablet: DEFAULT_EDITOR_PARAMS_DEVICE(),
  pc: DEFAULT_EDITOR_PARAMS_DEVICE(),
})

export const DEFAULT_EDITOR_DATA = (): EDITOR_DATA => ({
  id: null,
  classes: null,
  type: 'text',
  data: {
    value:
      'Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Praesent in mauris eu tortor porttitor accumsan. Nullam eget nisl. Aenean fermentum risus id tortor. Mauris tincidunt sem sed arcu. Donec quis nibh at felis congue commodo. Nulla est. Maecenas ipsum velit, consectetuer eu lobortis ut, dictum at dui. Phasellus enim erat, vestibulum vel, aliquam a, posuere eu, velit. Integer in sapien. Integer rutrum, orci vestibulum ullamcorper ultricies, lacus quam ultricies odio, vitae placerat pede sem sit amet enim. Maecenas sollicitudin.',
  },
})